import React from 'react'

function AvatarBig() {
  return (
    <>
      <svg
        width='90'
        height='90'
        viewBox='0 0 105 105'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='profile-photo'
      >
        <path
          d='M52.5 104.5C81.2188 104.5 104.5 81.2188 104.5 52.5C104.5 23.7812 81.2188 0.5 52.5 0.5C23.7812 0.5 0.5 23.7812 0.5 52.5C0.5 81.2188 23.7812 104.5 52.5 104.5Z'
          fill='#F5F6FA'
          stroke='white'
        />
        <path
          d='M52.5016 25.9688C43.0256 25.9688 35.335 34.3698 35.335 44.721C35.335 54.8723 42.6136 63.1233 52.2727 63.4233C52.4101 63.4233 52.5932 63.4233 52.6847 63.4233C52.7763 63.4233 52.9136 63.4233 53.0052 63.4233C53.051 63.4233 53.0967 63.4233 53.0967 63.4233C62.3439 63.0733 69.6225 54.8723 69.6683 44.721C69.6683 34.3698 61.9776 25.9688 52.5016 25.9688Z'
          fill='#0E1F33'
        />
        <path
          d='M88.3943 89.7711C78.9708 98.5759 66.3709 103.998 52.5004 103.998C38.6299 103.998 26.0299 98.5759 16.6064 89.7711C17.877 84.8855 21.3182 80.4294 26.3476 76.9934C40.8004 67.2222 64.3062 67.2222 78.6532 76.9934C83.7355 80.4294 87.1237 84.8855 88.3943 89.7711Z'
          fill='#0E1F33'
        />
      </svg>
    </>
  )
}

export default AvatarBig
